import { AxiosError } from 'axios';
import { ServerResponse, WithAuditDetails } from 'data/types';
import { History } from 'history';
import { Dispatch, Action } from 'redux';
import { RootState } from 'data/root.reducers';
import i18n from 'i18n';
import { showSuccessMessage, showError } from 'shared/toaster';
import { ThunkDispatch } from 'redux-thunk';
import { extractErrorMessage } from '../../utils';
import * as api from './iriBuffering.api';
import {
  GET_IRI_BUFFERING,
  UPDATE_IRI_BUFFERING,
  GO_TO_IRI_BUFFERING_EDIT,
  GO_TO_IRI_BUFFERING_VIEW,
  SELECT_IRI_BUFFERING,
  UpdateIRIBufferingThunkAction,
  IRIBufferingActionTypes,
  IRIBuffering,
  SelectIRIBufferingAction,
} from './iriBuffering.types';
import { IRI_BUFFERING_ROUTE, SYSTEM_CONFIGURATION_ROUTE, SYSTEM } from '../../constants';

export function goToIRIBufferingEdit(history: History): (dispatch: Dispatch) => void {
  return (dispatch: Dispatch) => {
    dispatch({
      type: GO_TO_IRI_BUFFERING_EDIT,
    });

    history.push(`${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${IRI_BUFFERING_ROUTE}/edit`);
  };
}

export function goIRIBufferingView(history: History): (dispatch: Dispatch) => void {
  return (dispatch: Dispatch) => {
    dispatch({
      type: GO_TO_IRI_BUFFERING_VIEW,
    });

    history.push(`${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${IRI_BUFFERING_ROUTE}`);
  };
}

export function getIRIBuffering(
  deliveryFunctionId: string,
): IRIBufferingActionTypes {
  return {
    type: GET_IRI_BUFFERING,
    payload: api.getIRIBuffering(deliveryFunctionId),
  };
}

export function updateIRIBuffering(
  deliveryFunctionId: string,
  body: WithAuditDetails<IRIBuffering>,
  history: History,
): UpdateIRIBufferingThunkAction {
  return async (dispatch: ThunkDispatch<RootState, unknown, Action<string>>) => {
    try {
      await dispatch({
        type: UPDATE_IRI_BUFFERING,
        payload: api.updateIRIBuffering(deliveryFunctionId, body),
      });

      dispatch(getIRIBuffering(deliveryFunctionId));
      dispatch(goIRIBufferingView(history));
      showSuccessMessage(i18n.t('iriBuffering.update.success'), 5000);

    } catch (e) {
      const errorMessage = extractErrorMessage(e as AxiosError<ServerResponse<void>>);
      showError(i18n.t('iriBuffering.update.failed', { name: body.data?.NAME, error: errorMessage }));
    }
  };
}

export function selectIRIBuffering(
  iriBuffering: IRIBuffering[],
): SelectIRIBufferingAction {
  return {
    type: SELECT_IRI_BUFFERING,
    payload: iriBuffering,
  };
}
